const constants = {
  NEW_ALERT_MESSAGE: "NEW_ALERT_MESSAGE",

  // Used

  UPDATE_MAIN_USER: "UPDATE_MAIN_USER",
  REMOVE_MAIN_USER: "REMOVE_MAIN_USER",
  UPLOAD_MAIN_USER_IMAGE: "UPLOAD_MAIN_USER_IMAGE",
  DELETE_MAIN_USER_IMAGE: "DELETE_MAIN_USER_IMAGE",
  UPLOAD_PROJECT_IMAGE: "UPLOAD_PROJECT_IMAGE",
  DELETE_PROJECT_IMAGE: "DELETE_PROJECT_IMAGE",
  UPDATE_MAIN_USER_EMAIL: "UPDATE_MAIN_USER_EMAIL",

  // CLIENTS
  UPDATE_CLIENTS: "UPDATE_CLIENTS",
  UPDATE_CLIENTS_STORE: "UPDATE_CLIENTS_STORE",
  UPSERT_CLIENT: "UPSERT_CLIENT",
  UPSERT_CLIENT_STORE: "UPSERT_CLIENT_STORE",
  REMOVE_CLIENT: "REMOVE_CLIENT",
  REMOVE_CLIENT_STORE: "REMOVE_CLIENT_STORE",

  // PROJECT MANAGERS
  SEND_GET_PROJECT_MANAGERS: "SEND_GET_PROJECT_MANAGERS",
  SEND_ADD_PROJECT_MANAGER: "SEND_ADD_PROJECT_MANAGER",
  SEND_EDIT_PROJECT_MANAGER: "SEND_EDIT_PROJECT_MANAGER",
  SEND_REMOVE_PROJECT_MANAGER: "SEND_REMOVE_PROJECT_MANAGER",
  UPDATE_PROJECT_MANAGERS: "UPDATE_PROJECT_MANAGERS",
  ADD_PROJECT_MANAGER: "ADD_PROJECT_MANAGER",
  EDIT_PROJECT_MANAGER: "EDIT_PROJECT_MANAGER",
  REMOVE_PROJECT_MANAGER: "REMOVE_PROJECT_MANAGER",

  // CLIENTS RESERVATIONS
  // UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID: "UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID",
  // UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID_STORE: "UPDATE_CLIENT_RESERVATIONS_BY_CLIENT_ID_STORE",
  UPDATE_CLIENT_RESERVATIONS: " UPDATE_CLIENT_RESERVATIONS",
  UPDATE_CLIENT_RESERVATIONS_STORE: "UPDATE_CLIENT_RESERVATIONS_STORE",
  UPSERT_CLIENT_RESERVATION: "UPSERT_CLIENT_RESERVATION",
  UPSERT_CLIENT_RESERVATION_STORE: "UPSERT_CLIENT_RESERVATION_STORE",
  REMOVE_CLIENT_RESERVATION: "REMOVE_CLIENT_RESERVATION",
  REMOVE_CLIENT_RESERVATION_STORE: "REMOVE_CLIENT_RESERVATION_STORE",

  UPDATE_ONNA_DEVICES: "UPDATE_ONNA_DEVICES",
  GET_ONNA_DEVICES_STATE: "GET_ONNA_DEVICES_STATE",
  UPDATE_ONNA_DEVICES_STATE: "UPDATE_ONNA_DEVICES_STATE",
  REMOVE_ONNA_DEVICES: "REMOVE_ONNA_DEVICES",
  ADD_ONNA_DEVICE_TO_PROJECT: "ADD_ONNA_DEVICE_TO_PROJECT",
  REMOVE_ONNA_DEVICES_FROM_PROJECT: "REMOVE_ONNA_DEVICES_FROM_PROJECT",
  UPDATE_APARTMENTS: "UPDATE_APARTMENTS",
  REMOVE_APARTMENTS: "REMOVE_APARTMENTS",
  UPDATE_PROJECTS: "UPDATE_PROJECTS",
  REMOVE_PROJECTS: "REMOVE_PROJECTS",
  SEND_METRICS_LIMITS_BY_PROJECT: "SEND_METRICS_LIMITS_BY_PROJECT",

  // RESERVATIONS
  GET_ALL_AMENTIES: "GET_ALL_AMENTIES",
  UPDATE_AMENTIES_STORE: "UPDATE_AMENTIES_STORE",
  UPDATE_AMENITY: "UPDATE_AMENITY",
  UPDATE_AMENITY_STORE: "UPDATE_AMENITY_STORE",
  REMOVE_AMENTIES: "REMOVE_AMENTIES",
  REMOVE_AMENTIES_STORE: "REMOVE_AMENTIES_STORE",

  // RESERVATION EVENTS
  GET_AMENITY_EVENTS: "GET_AMENITY_EVENTS",
  UPDATE_AMENITY_EVENTS_STORE: "UPDATE_AMENITY_EVENTS_STORE",
  UPDATE_AMENITY_EVENT: "UPDATE_AMENITY_EVENT",
  UPDATE_AMENITY_EVENT_STORE: "UPDATE_AMENITY_EVENT_STORE",
  REMOVE_AMENITY_EVENT: "REMOVE_AMENITY_EVENT",
  REMOVE_AMENITY_EVENT_STORE: "REMOVE_AMENITY_EVENT_STORE",

  // SERVICES
  GET_ALL_SERVICES: "GET_ALL_SERVICES",
  UPDATE_SERVICE: "UPDATE_SERVICE",
  UPDATE_SERVICE_STORE: "UPDATE_SERVICE_STORE",
  UPDATE_ALL_SERVICES_STORE: "UPDATE_ALL_SERVICES_STORE",
  REMOVE_SERVICES: "REMOVE_SERVICES",
  REMOVE_SERVICES_STORE: "REMOVE_SERVICES_STORE",

  // SERVICE CATEGORIES
  GET_ALL_SERVICE_CATEGORIES: "GET_ALL_SERVICE_CATEGORIES",
  UPDATE_ALL_SERVICES_CATEGORIES_STORE: "UPDATE_ALL_SERVICES_CATEGORIES_STORE",
  UPDATE_SERVICE_CATEGORY: "UPDATE_SERVICE_CATEGORY",
  UPDATE_SERVICE_CATEGORY_STORE: "UPDATE_SERVICE_CATEGORY_STORE",
  REMOVE_SERVICE_CATEGORIES: "REMOVE_SERVICE_CATEGORIES",
  REMOVE_SERVICE_CATEGORIES_STORE: "REMOVE_SERVICE_CATEGORIES_STORE",

  // SERVICE EVENTS
  GET_SERVICE_EVENTS: "GET_SERVICE_EVENTS",
  UPDATE_SERVICE_EVENTS_STORE: "UPDATE_SERVICE_EVENTS_STORE",
  UPDATE_SERVICE_EVENT: "UPDATE_SERVICE_EVENT",
  UPDATE_SERVICE_EVENT_STORE: "UPDATE_SERVICE_EVENT_STORE",
  REMOVE_SERVICE_EVENT: "REMOVE_SERVICE_EVENT",
  REMOVE_SERVICE_EVENT_STORE: "REMOVE_SERVICE_EVENT_STORE",

  // SUPPORT CASES
  GET_ALL_SUPPORT_CASES: "GET_ALL_SUPPORT_CASES",
  UPDATE_SUPPORT_CASES_STORE: "UPDATE_SUPPORT_CASES_STORE",

  UPDATE_SUPPORT_CASE: "UPDATE_SUPPORT_CASE",
  UPDATE_SUPPORT_CASE_STORE: "UPDATE_SUPPORT_CASE_STORE",

  REMOVE_SUPPORT_CASE: "REMOVE_SUPPORT_CASE",
  REMOVE_SUPPORT_CASE_STORE: "REMOVE_SUPPORT_CASE_STORE",

  // Chat
  UPDATE_CHAT_STORE: "UPDATE_CHAT_STORE",
  GET_ALL_CHAT_MESSAGES: "GET_ALL_CHAT_MESSAGES",
  SEND_CHAT_MESSAGE: "SEND_CHAT_MESSAGE",
  SEND_CHAT_READ_EVENT: "SEND_CHAT_READ_EVENT",
  DELETE_CHAT_MESSAGE: "DELETE_CHAT_MESSAGE",
  ADD_CHAT_MESSAGE_STORE: "ADD_CHAT_MESSAGE_STORE",

  // Occupancy
  UPDATE_OCCUPANCY: "UPDATE_OCCUPANCY",
  REMOVE_OCCUPANCY: "REMOVE_OCCUPANCY",
  GET_OCCUPANCY_DATA: "GET_OCCUPANCY_DATA",
  GET_OCCUPANCY_DATA_XLSX: "GET_OCCUPANCY_DATA_XLSX",

  // Modal
  SHOW_MODAL: "SHOW_MODAL",

  // Addresses
  INIT_ADDRESSES_STORE: "INIT_ADDRESSES_STORE",
  EDIT_ADDRESS_STORE: "EDIT_ADDRESS_STORE",
  SEND_VALUE_SERVER: "SEND_VALUE_SERVER",

  // ONNA configuration version
  INIT_VERSION_SERVER: "INIT_VERSION_SERVER",
  INIT_VERSION_STORE: "INIT_VERSION_STORE",

  // ONNA configuration tree
  INIT_CONFIGURATION_SERVER: "INIT_CONFIGURATION_SERVER",
  INIT_CONFIGURATION_STORE: "INIT_CONFIGURATION_STORE",

  // Settings
  SETTINGS_SAVE_DATA: "SETTINGS_SAVE_DATA",
  SETTINGS_SEND_DATA: "SETTINGS_SEND_DATA",
  SEND_DATE_TIME: "SEND_DATE_TIME",
  GET_DATE_TIME: "GET_DATE_TIME",
  UPDATE_APP: "UPDATE_APP",
  GET_IP_ADDRESS: "GET_IP_ADDRESS",
  REBOOT_ONNA: "REBOOT_ONNA",
  SEND_PROTECT_SETTINGS_PAGE: "SEND_PROTECT_SETTINGS_PAGE",
  ASK_NAVIGATE_PERMISSION: "ASK_NAVIGATE_PERMISSION",

  // SEND_GET_USERS_LIST: "SEND_GET_USERS_LIST",
  CHECK_CAPTCHA: "CHECK_CAPTCHA",
  CREATE_MAIN_USER: "CREATE_MAIN_USER",
  SEND_REMOVE_USER_LIST: "SEND_REMOVE_USER_LIST",
  SEND_CHANGE_OPEN_STATE: "SEND_CHANGE_OPEN_STATE",

  // ACCESS CONTROL

  ACCESS_CONTROL_CHECK_CREDENTIALS: "ACCESS_CONTROL_CHECK_CREDENTIALS",
  ACCESS_CONTROL_GET_LOCKS: "ACCESS_CONTROL_GET_LOCKS",
  ACCESS_CONTROL_GET_LOCK_DETAIL: "ACCESS_CONTROL_GET_LOCK_DETAIL",
  ACCESS_CONTROL_LOCK_UNLOCK: "ACCESS_CONTROL_LOCK_UNLOCK",
  ACCESS_CONTROL_GET_LOCK_PASSWORDS: "ACCESS_CONTROL_GET_LOCK_PASSWORDS",
  ACCESS_CONTROL_REMOVE_LOCK_PASSWORD: "ACCESS_CONTROL_REMOVE_LOCK_PASSWORD",
  ACCESS_CONTROL_GET_LOCK_DETAIL_CLIENT: "ACCESS_CONTROL_GET_LOCK_DETAIL_CLIENT",
  ACCESS_CONTROL_LOCK_UNLOCK_CLIENT: "ACCESS_CONTROL_LOCK_UNLOCK_CLIENT",
  ACCESS_CONTROL_CREATE_PASSWORD: "ACCESS_CONTROL_CREATE_PASSWORD",

  // CLOUD APIS

  SET_CLOUD_APIS_APARTMENT: "SET_CLOUD_APIS_APARTMENT",

  // SocketIO
  INIT_SOCKET: "INIT_SOCKET",
  END_SOCKET: "END_SOCKET",
  INIT_CLIENT: "INIT_CLIENT",
  INIT_MAIN_USER_SOCKET: "INIT_MAIN_USER_SOCKET",
  OPEN_CLIENT_RESERVATION_SELECTOR: "OPEN_CLIENT_RESERVATION_SELECTOR",
  SELECT_CLIENT_RESERVATION: "SELECT_CLIENT_RESERVATION",
  CLOSE_CLIENT_RESERVATION_SELECTOR: "CLOSE_CLIENT_RESERVATION_SELECTOR",
  SOCKET_CONNECTION_TYPE: "SOCKET_CONNECTION_TYPE",
  ONNA_SOCKET_STATUS: "ONNA_SOCKET_STATUS",
  SERVER_SOCKET_STATUS: "SERVER_SOCKET_STATUS",
  SOCKET_INFO: "SOCKET_INFO",
  SOCKET_STATUS: "SOCKET_STATUS",

  // Connection
  LAST_CONNECTION: "LAST_IP_CONNECTION",

  // Settings
  WEATHER_CITY: "WEATHER_CITY",
  WEATHER_DATA: "WEATHER_DATA",
  UPDATE_WEATHER_DATA: "UPDATE_WEATHER_DATA",

  // Device
  CHANGE_DEVICE_NAME: "CHANGE_DEVICE_NAME",

  // Schedules
  INIT_SCHEDULES_SERVER: "INIT_SCHEDULES_SERVER",
  SAVE_SCHEDULES_STORE: "SAVE_SCHEDULES_STORE",
  UPDATE_SCHEDULES_STORE: "UPDATE_SCHEDULES_STORE",

  SEND_NEW_SCHEDULE_SERVER: "SEND_NEW_SCHEDULE_SERVER",
  SEND_EDIT_SCHEDULE_SERVER: "SEND_EDIT_SCHEDULE_SERVER",
  SEND_REMOVE_SCHEDULE_SERVER: "SEND_REMOVE_SCHEDULE_SERVER",
  SEND_ENABLE_SCHEDULES_SERVER: "SEND_ENABLE_SCHEDULES_SERVER",

  // Notifications
  UPDATE_NOTIFICATIONS: "UPDATE_NOTIFICATIONS",
  UPDATE_BADGE_NOTIFICATIONS: "UPDATE_BADGE_NOTIFICATIONS",
  REMOVE_NOTIFICATIONS: "REMOVE_NOTIFICATIONS",
  SEND_READ_NOTIFICATION_SERVER: "SEND_READ_NOTIFICATION_SERVER",
  SEND_REMOVE_NOTIFICATION_SERVER: "SEND_REMOVE_NOTIFICATION_SERVER",

  // Reset LogOut
  RESET_APP: "RESET_APP",

  // Alarm
  INIT_ALARM_SERVER: "INIT_ALARM_SERVER",
  UPDATE_ALARM_STORE: "UPDATE_ALARM_STORE",
  SEND_ARM_ALARM_SERVER: "SEND_ARM_ALARM_SERVER",
  SEND_DISARM_ALARM_SERVER: "SEND_DISARM_ALARM_SERVER",
  SEND_CHANGE_PASSWORD_ALARM_SERVER: "SEND_CHANGE_PASSWORD_ALARM_SERVER",

  // Global
  SEND_GROUP_ACTION_SERVER: "SEND_GROUP_ACTION_SERVER",
  SEND_EDIT_ROOM_NAME_SERVER: "SEND_EDIT_ROOM_NAME_SERVER",
  SEND_EDIT_ROOM_COLOR_SERVER: "SEND_EDIT_ROOM_COLOR_SERVER",
  SEND_EDIT_DEVICE_NAME_SERVER: "SEND_EDIT_DEVICE_NAME_SERVER",
  ONNA_GLOBAL_POPUP_MSG: "ONNO_GLOBAL_POPUP_MSG",
  SEND_BUZZER_CLICK_SERVER: "SEND_BUZZER_CLICK_SERVER",

  // Macros

  INIT_MACROS_SERVER: "INIT_MACROS_SERVER",
  SAVE_MACROS_STORE: "SAVE_MACROS_STORE",
  UPDATE_MACROS_STORE: "UPDATE_MACROS_STORE",
  SEND_NEW_MACRO_SERVER: "SEND_NEW_MACRO_SERVER",
  SEND_EDIT_MACRO_SERVER: "SEND_EDIT_MACRO_SERVER",
  SEND_REMOVE_MACRO_SERVER: "SEND_REMOVE_MACRO_SERVER",
  SEND_EXECUTE_MACRO_SERVER: "SEND_EXECUTE_MACRO_SERVER",

  // Intercoms
  INIT_INTERCOMS_SERVER: "INIT_INTERCOMS_SERVER",
  UPDATE_INTERCOMS_STORE: "UPDATE_INTERCOMS_STORE",
  SEND_NEW_CALL_STATE_SERVER: "SEND_NEW_CALL_STATE_SERVER",
  SEND_NEW_VOLUMES_SERVER: "SEND_NEW_VOLUMES_SERVER",
  SEND_TEST_AUDIO_SERVER: "SEND_TEST_AUDIO_SERVER",

  // System
  KNX_STATE_FROM_SERVER: "KNX_STATE_FROM_SERVER",
  INTERNET_STATE_FROM_SERVER: "INTERNET_STATE_FROM_SERVER",

  // Favourites
  NEW_FAVOURITES_FROM_SERVER: "NEW_FAVOURITES_FROM_SERVER",
  SEND_NEW_FAVOURITES_SERVER: "SEND_NEW_FAVOURITES_SERVER",

  // Trends
  GET_TREND_DATA: "GET_TREND_DATA",
  GET_TREND_DATA_XLSX: "GET_TREND_DATA_XLSX",
  SET_TREND_DATA: "SET_TREND_DATA",
  SET_TRENDS: "SET_TRENDS",
  SET_TRENDS_HISTORY: "SET_TRENDS_HISTORY",
  STORE_TREND_HISTORY: "STORE_TREND_HISTORY",
  REMOVE_TREND_DATA: "REMOVE_TREND_DATA",

  // ThermostatIp
  UPDATE_DEVICE: "UPDATE_DEVICE",
  CLEAN_STATE: "CLEAN_STATE",
  CHANGE_THERMOSTATIP_VALUE: "CHANGE_THERMOSTATIP_VALUE",

  // Bacnet
  INIT_BACNET_ADDRESSES_STORE: "INIT_BACNET_ADDRESSES_STORE",
  UPDATE_BACNET_ADDRESSES_STORE: "UPDATE_BACNET_ADDRESSES_STORE",

  // INFLUX
  MAKE_QUERY: "MAKE_QUERY",
};

export default constants;
